import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import {
  ContractTerminationReasonAction,
  contractTerminationReasonActions,
} from './contract-termination-reason.actions';
import { ContractTerminationReasonApiService } from './contract-termination-reason.api.service';

@Injectable()
export class ContractTerminationReasonEffects {
  constructor(
    private readonly contractTerminationReasonApiService: ContractTerminationReasonApiService,
    private readonly action$: Actions<ContractTerminationReasonAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    contractTerminationReasonActions.getById,
    this.contractTerminationReasonApiService.getById,
  );

  createInstance = createApiCallEffects(
    this,
    this.action$,
    contractTerminationReasonActions.createInstance,
    this.contractTerminationReasonApiService.createInstance,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    contractTerminationReasonActions.add,
    this.contractTerminationReasonApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    contractTerminationReasonActions.update,
    this.contractTerminationReasonApiService.update,
  );
}
